import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ProductServiceParamsInterface } from '@interfaces/products/product_service_params_interface';
import { Observable } from 'rxjs';
import { ApiResponse } from '@interfaces/api/api.interface';
import { SearchArtisantAndProductsDataInterface } from '@interfaces/searcher/search_artisant_and_products_data_interface';
import { LanguageService } from '@core/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class SearcherService {
  private http = inject(HttpClient);
  private searcherEnpoint = environment.endpoints.searcher;
  private api = environment.API_URL;
  private locale = inject(LanguageService);

  public searchProductsAndArtisans(
    params: ProductServiceParamsInterface
  ): Observable<ApiResponse<SearchArtisantAndProductsDataInterface>> {
    const localeParams: ProductServiceParamsInterface = {
      ...params,
      locale: this.locale.currentLanguage().toUpperCase(),
    };
    let httpParams = new HttpParams();

    (Object.keys(localeParams) as (keyof ProductServiceParamsInterface)[]).forEach(key => {
      const value = localeParams[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(String(key), String(value));
      }
    });

    return this.http.get<ApiResponse<SearchArtisantAndProductsDataInterface>>(`${this.api}/${this.searcherEnpoint}`, {
      params: httpParams,
    });
  }
}
